"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class StoreBranch {
    constructor(data = null, params = null, errors = null, loading = false) {
        this.data = data;
        this.params = params;
        this.errors = errors;
        this.loading = loading;
    }
}
exports.StoreBranch = StoreBranch;
//# sourceMappingURL=StoreBranch.js.map